module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.obj.open),
      expression: "obj.open"
    }],
    staticClass: "gallery page"
  }, [_c('div', {
    staticClass: "prev",
    on: {
      "click": function($event) {
        _vm.change(-1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "next",
    on: {
      "click": function($event) {
        _vm.change(1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('transition-group', {
    attrs: {
      "tag": "div",
      "mode": "out-in",
      "duration": 1000
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, _vm._l((_vm.images), function(image, i) {
    return _c('v-touch', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i == _vm.obj.selected),
        expression: "i == obj.selected"
      }],
      key: image,
      staticClass: "slide",
      attrs: {
        "tag": "img",
        "src": '/dist/' + image
      },
      on: {
        "swipeleft": function($event) {
          _vm.change(1)
        },
        "swiperight": function($event) {
          _vm.change(-1)
        }
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, _vm._l((_vm.images), function(image, i) {
    return _c('span', {
      staticClass: "dot",
      class: {
        active: i == _vm.obj.selected
      },
      on: {
        "click": function($event) {
          _vm.select(i)
        }
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86fcaabc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/galery.vue
// module id = 159
// module chunks = 0